import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ProfileComponent } from './profile/profile.component';
import { RegistrationThanksComponent } from './registration-thanks/registration-thanks.component';
import { ReservedAreaComponent } from './reserved-area/reserved-area.component';
import { LogoutComponent } from './logout/logout.component';
import { NewTenderComponent } from './new-tender/new-tender.component';
import { NewClusterTenderComponent } from './new-cluster-tender/new-cluster-tender.component';
import { BuyNewTenderComponent } from './buy-new-tender/buy-new-tender.component';
import { BuyNewClusterTenderComponent } from './buy-new-cluster-tender/buy-new-cluster-tender.component';
import { BuyNewTenderThanksComponent } from './buy-new-tender-thanks/buy-new-tender-thanks.component';
import { OngoingTendersComponent } from './ongoing-tenders/ongoing-tenders.component';
import { BuyTenderParticipationComponent } from './buy-tender-participation/buy-tender-participation.component';
import { BuyTenderParticipationThanksComponent } from './buy-tender-participation-thanks/buy-tender-participation-thanks.component';
import { BuyPrepaidPacketComponent } from './buy-prepaid-packet/buy-prepaid-packet.component';
import { BuyPrepaidPacketThanksComponent } from './buy-prepaid-packet-thanks/buy-prepaid-packet-thanks.component';
import { AcceptInvitationComponent } from './accept-invitation/accept-invitation.component';
import { ReservedAreaAccessDeniedComponent } from './reserved-area-access-denied/reserved-area-access-denied.component';
import { QuoteRequestComponent } from './quote-request/quote-request.component';
import { BuyQuoteRequestComponent } from './buy-quote-request/buy-quote-request.component';
import { BuyQuoteRequestThanksComponent } from './buy-quote-request-thanks/buy-quote-request-thanks.component';
import { BuyUpgradeComponent } from './buy-upgrade/buy-upgrade.component';
import { BuyUpgradeErrorComponent } from './buy-upgrade-error/buy-upgrade-error.component';
import { ShowcaseCompanyComponent } from './showcase-company/showcase-company.component';
import { ShowcaseProfessionalComponent } from './showcase-professional/showcase-professional.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackThanksComponent } from './feedback-thanks/feedback-thanks.component';
import { FeedbackErrorComponent } from './feedback-error/feedback-error.component';
import { ShowcaseAnnouncementComponent } from './showcase-announcement/showcase-announcement.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'passwordpersa', component: LostPasswordComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'confermaemail', component: ConfirmEmailComponent },
  { path: 'profilo', component: ProfileComponent },
  { path: 'grazie', component: RegistrationThanksComponent },
  { path: 'areariservata', component: ReservedAreaComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'creaunagara', component: NewTenderComponent },
  { path: 'acquistacreazionegara', component: BuyNewTenderComponent },
  { path: 'grazieacquisto', component: BuyNewTenderThanksComponent },
  { path: 'gareincorso', component: OngoingTendersComponent },
  { path: 'acquistapartecipazioneallagara', component: BuyTenderParticipationComponent },
  { path: 'grazieacquistopartecipazione', component: BuyTenderParticipationThanksComponent },
  { path: 'acquistapacchetto', component: BuyPrepaidPacketComponent },
  { path: 'grazieacquistopacchetto', component: BuyPrepaidPacketThanksComponent },
  { path: 'accettainvito', component: AcceptInvitationComponent },
  { path: 'accessonegatoareariservata', component: ReservedAreaAccessDeniedComponent },
  { path: 'richiestapreventivo', component: QuoteRequestComponent },
  { path: 'acquistarichiestapreventivo', component: BuyQuoteRequestComponent},
  { path: 'grazieacquistarichiestapreventivo', component: BuyQuoteRequestThanksComponent},
  { path: 'acquistaupgrade', component: BuyUpgradeComponent},
  { path: 'erroreacquistoupgrade', component: BuyUpgradeErrorComponent},
  { path: 'aziende', component: ShowcaseCompanyComponent},
  { path: 'professionisti', component: ShowcaseProfessionalComponent},
  { path: 'feedback', component:FeedbackComponent},
  { path: 'feedback-ringraziamento', component:FeedbackThanksComponent},
  { path: 'feedback-errore', component:FeedbackErrorComponent},
  { path: 'annunci', component: ShowcaseAnnouncementComponent },
  { path: 'creaunagaracluster', component: NewClusterTenderComponent },
  { path: 'acquistacreazionegaracluster', component: BuyNewClusterTenderComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
